export default ({ store, redirect, route }) => {
    if (!store.getters.user) {
        return redirect('/login')
    }
    if (!store.getters.canAgent) {
        return redirect(302, '/survey/', route.query)
    }
}
